export const getIsDocumentDefined = () => typeof document !== 'undefined';
